module.exports = __webpack_public_path__ + "img/apaym-pay.88490366.png";